import { Box, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import EnhancedTable from 'Shared/EnhancedTable';
import usePageable from 'Shared/Hooks/usePageable';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
import ProductDetail from 'Components/Catalog/Products/ProductDetail/v1';
import { columns } from './constants';

const ResultByRef = ({
  products, brands, families, filters,
  onChangeFilter, handleNextTecdocArticles, totalTecdocArticles,
}) => {
  const [openProductDetail, setOpenProductDetail] = useState(false);
  const [product, setProduct] = useState(null);
  const [page, rows, setPage] = usePageable(0, 20);
  const onChangeSelect = (name) => (e, value) => {
    onChangeFilter({ target: { name, value } });
  };
  const handleLine = (p) => {
    setProduct(p);
    setOpenProductDetail(true);
  };
  const handleNext = (nextPage) => {
    handleNextTecdocArticles();
    setPage(nextPage);
  };
  const mergedProducts = useMemo(() => [...products.copima, ...products.tecdoc]
    ?.slice(page * rows, page * rows + rows)
    ?.map((p) => {
      if (p.articleNumber) {
        const tec = {
          reference: p.articleNumber,
          isTecdoc: true,
          des: p.genericArticles?.length > 0
            ? p.genericArticles[0].genericArticleDescription : '',
          img: p.images?.length > 0 ? p.images[0]?.imageURL400 : null,
          bId: p.mfrName || '-',
          ...p,
        };
        const click = () => handleLine(tec);
        return { ...tec, click };
      }
      return { ...p, click: () => handleLine(p) };
    }) || [],
  [products, page, rows]);

  const totalProducts = totalTecdocArticles + (products.copima?.length || 0);

  if (totalProducts === 0) {
    return null;
  }
  return (
    <Box sx={{ mb: 2 }}>
      <Typography sx={{ font: 'normal normal 600 24px Montserrat' }}>Résultat de recherche</Typography>
      <Box sx={{
        display: 'flex', borderRadius: 1.5, background: '#E9EBED', p: 1.5, mt: 1, mb: 1,
      }}
      >
        <AutoCompleteCmp
          options={families || []}
          onChange={onChangeSelect('tecdocFamily')}
          value={filters.tecdocFamily}
          label="Catégorie"
          filterOptions={
            (ops, v) => ops.filter(
              (o) => !v.inputValue
                  || o.genericArticleDescription
                    ?.toLowerCase()
                    .includes(v.inputValue.toLowerCase()),
            )
          }
          getOptionLabel={(v) => (`${v.genericArticleDescription} (${v.count})`)}
          isPrimaryTheme
          style={{ marginBottom: 4, width: 250, maxWidth: 250 }}
        />
        <AutoCompleteCmp
          options={brands || []}
          disabled={!filters.tecdocFamily}
          value={filters.tecdocBrand || []}
          onChange={onChangeSelect('tecdocBrand')}
          label="Marques"
          name="brand"
          isPrimaryTheme
          multiple
          getOptionLabel={(option) => (`${option.mfrName} (${option.count})`)}
          filterOptions={(options, v) => options
            .filter((option) => option.mfrName?.toLowerCase().includes(v.inputValue.toLowerCase()))}
          style={{ marginBottom: 4, width: 250, maxWidth: 250 }}
        />
      </Box>
      {openProductDetail && (
        <ProductDetail
          product={product}
          isTecDoc={product.isTecdoc}
          handleClose={() => setOpenProductDetail(false)}
          onClose={() => setOpenProductDetail(false)}
        />
      )}
      <EnhancedTable
        rows={mergedProducts}
        headCells={columns}
        count={totalProducts}
        rowsPerPageOptions={[20]}
        // onChangeRowsPerPage={setRows}
        onChangePage={handleNext}
      />
    </Box>
  );
};

export default ResultByRef;
